export default __webpack_public_path__ + "static/media/330_dummy2016-deko01-de-mobile.6be46d13.png";